// @ts-nocheck
import * as React from "react";

const StoreUser: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.348 11.598A3.75 3.75 0 0 1 6 10.5h6a3.75 3.75 0 0 1 3.75 3.75v1.5a.75.75 0 0 1-1.5 0v-1.5A2.25 2.25 0 0 0 12 12H6a2.25 2.25 0 0 0-2.25 2.25v1.5a.75.75 0 0 1-1.5 0v-1.5a3.75 3.75 0 0 1 1.098-2.652ZM9 3a2.25 2.25 0 1 0 0 4.5A2.25 2.25 0 0 0 9 3ZM5.25 5.25a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(StoreUser);
